import React, { createContext, useContext, ReactNode } from 'react';
import { useAudioPlayer } from '@/hooks/useAudioPlayer';
import { AudioItem } from '@/components/ui/audio-player';

interface AudioPlayerContextType {
    audios: AudioItem[];
    isVisible: boolean;
    setAudios: (audios: AudioItem[]) => void;
    showPlayer: () => void;
    hidePlayer: () => void;
    closePlayer: () => void;
    openSettings: () => void;
}

const AudioPlayerContext = createContext<AudioPlayerContextType | undefined>(undefined);

interface AudioPlayerProviderProps {
    children: ReactNode;
}

export function AudioPlayerProvider({ children }: AudioPlayerProviderProps) {
    const audioPlayerState = useAudioPlayer();

    return (
        <AudioPlayerContext.Provider value={audioPlayerState}>
            {children}
        </AudioPlayerContext.Provider>
    );
}

export function useAudioPlayerContext() {
    const context = useContext(AudioPlayerContext);
    if (context === undefined) {
        throw new Error('useAudioPlayerContext must be used within an AudioPlayerProvider');
    }
    return context;
} 